// Never infer an operator from the conversation's current owner.
export function messageSenderLabel(message, users = []) {
  if (message?.remetente === "aurora") return "Aurora";
  if (message?.commercialFollowUp || message?.remetente === "automacao_comercial") return "Automação comercial";
  if (message?.remetente === "cliente" || message?.remetente === "client") return "Cliente";
  if (typeof message?.senderName === "string" && message.senderName.trim()) return message.senderName.trim();
  const senderId = Number(message?.senderUserId);
  const sender = senderId > 0 ? users.find(user => Number(user.id) === senderId) : null;
  return sender?.name || "Autor não identificado";
}
